import { CreateOrderRequest } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 1000000000;

export interface UpdateItemQuantityPayload {
    activityId: string;
    itemId: string;
    amount: number;
}

export const updateItemQuantity = (state: WritableDraft<Record<string, CreateOrderRequest>>, action: PayloadAction<UpdateItemQuantityPayload>) => {
    const { activityId, itemId, amount } = action.payload;
    const activityState = state[activityId];
    if (!activityState) return;
    const { orderLines } = activityState;
    const itemIndex = orderLines
        .findIndex((it) => it.shopItemId === itemId);
    if (itemIndex === -1) {
        return;
    }
    const item = orderLines[itemIndex];
    const newQuantity = item.quantity + amount;

    if (newQuantity < MIN_QUANTITY || newQuantity > MAX_QUANTITY) {
        return;
    }
    activityState.orderLines[itemIndex].quantity = newQuantity;
};
